import React from "react";

import { Container, IconEnd } from "./styles";

export default (props) => (
  <Container
    selectedConfirm={props.selectedColor ? "block" : "none"}
    colorContent={props.colorContent}
  >
    <i className={props.classIcon} />
    <p>{props.nameItem}</p>
    {props.classIconEnd && <IconEnd className={props.classIconEnd} />}
  </Container>
);
